define(function(require, exports, module) {
    'use strict';

    var tmpl = require('tmpl');
    const i18n = require('i18n');
    var Form = require('class/form.class');

    /**
     * @override - replacement for showErrorMessage in core, used for errors and success
     * @returns {Form}
     */
    Form.prototype.showErrorMessage = function(data = {}) {
        this.$el.find('.fn-form-messages').html(tmpl['common.messages']({
            className: data.className || 'error',
            content: data.errorMessage || i18n.tExt(data.translation, data.content) || 'System Error'
        }));

        return this;
    };

    module.exports = Form;
});
